import { useTranslation } from 'react-i18next'

import { AccountSettings } from 'pages/settings/AccountSettings'
import { JustCheckboxCards } from 'pages/settings/layout/JustCheckboxCards'
import { ChangeDisplayName } from 'pages/settings/pages/accountSettings/ChangeDisplayName'
import { ChangeEmail } from 'pages/settings/pages/accountSettings/ChangeEmail'
import { ChangePassword } from 'pages/settings/pages/accountSettings/ChangePassword'
import { ChangePhone } from 'pages/settings/pages/accountSettings/ChangePhone'
import { ChangeUsername } from 'pages/settings/pages/accountSettings/ChangeUsername'
import { ConnectAnotherAccount } from 'pages/settings/pages/accountSettings/ConnectAnotherAccount'
import { LoginSessions } from 'pages/settings/pages/LoginSessions'
import { AuthentificatorApp } from 'pages/settings/pages/privacySettings/AuthentificatorApp'
import { BlockedUsers } from 'pages/settings/pages/privacySettings/BlockedUsers'
import { Discovery } from 'pages/settings/pages/privacySettings/Discovery'
import { GeoBlocking } from 'pages/settings/pages/privacySettings/GeoBlocking'
import { RestrictedUsers } from 'pages/settings/pages/privacySettings/RestrictedUsers'
import { TwoStepVerification } from 'pages/settings/pages/privacySettings/TwoStepVerification'
import { WatermarkSettings } from 'pages/settings/pages/privacySettings/WatermarkSettings'
import { PrivacyAndSecurity } from 'pages/settings/view/PrivacyAndSecurity'

export const useSettingsRoutesAccount = () => {
    const { t } = useTranslation()

    return [
        {
            path: '/settings/account',
            Component: <AccountSettings />,
            roles: ['model', 'fan'],
            exact: true
        },
        {
            path: '/settings/account/change-display-name',
            Component: <ChangeDisplayName />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/account/change-username',
            Component: <ChangeUsername />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/account/change-email',
            Component: <ChangeEmail />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/account/change-password',
            Component: <ChangePassword />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/account/change-phone',
            Component: <ChangePhone />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/account/connect-another-account',
            Component: <ConnectAnotherAccount />,
            roles: ['model']
        },
        {
            path: '/settings/account/connect-social-accounts',
            Component: (
                <JustCheckboxCards
                    main={t('account')}
                    page='connect-social-accounts'
                />
            ),
            roles: ['model', 'fan']
        },
        {
            path: '/settings/account/privacy-and-security',
            Component: <PrivacyAndSecurity />,
            roles: ['model', 'fan'],
            exact: true
        },
        {
            path: '/settings/account/privacy-and-security/login-sessions',
            Component: <LoginSessions />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/account/privacy-and-security/two-step-verification',
            Component: <TwoStepVerification />,
            roles: ['model', 'fan'],
            exact: true
        },
        {
            path: '/settings/account/privacy-and-security/two-step-verification/authentificator-app',
            Component: <AuthentificatorApp />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/account/privacy-and-security/two-step-verification/sms-verification',
            Component: <AuthentificatorApp />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/account/privacy-and-security/blocked-users',
            Component: <BlockedUsers />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/account/privacy-and-security/restricted-users',
            Component: <RestrictedUsers />,
            roles: ['model']
        },
        {
            path: '/settings/account/privacy-and-security/watermark-settings',
            Component: <WatermarkSettings />,
            roles: ['model']
        },
        {
            path: '/settings/account/privacy-and-security/geo-blocking',
            Component: <GeoBlocking />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/account/privacy-and-security/discovery-settings',
            Component: <Discovery />,
            roles: ['model', 'fan']
        }
    ]
}
